import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon, toast } from '@livable/saas-react-components';
import { Button, IconButton, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import { useStore } from 'src/stores';
import PropTypes from 'prop-types';
import useStyles from './styles';
import { RemoveFileModal } from 'src/components/shared/RemoveFileModal';
import { parseCsv } from 'src/pages/AllocationTablesPage/AllocationSubmeteredUtility/tools';
export default function CsvFileUploader(_ref) {
  let _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? undefined : _ref$callback,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$noPreview = _ref.noPreview,
    noPreview = _ref$noPreview === void 0 ? true : _ref$noPreview,
    residenciesData = _ref.residenciesData;
  const store = useStore();
  const classes = useStyles();
  const fileInputRef = useRef();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDrag = _useState2[0],
    setIsDrag = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFilePreviewModalOpen = _useState6[0],
    setIsFilePreviewModalOpen = _useState6[1];
  const handleFileChange = async e => {
    e.preventDefault();
    if (e.target.files.length > 0) {
      var _uploadedFileResult;
      // NOTE: base is 1MB * 100
      if (e.target.files[0].size >= 1048576 * 100) {
        toast('error', {
          body: ['File is too large, maximum file size is 100 MB']
        });
        return;
      }
      setValue(e.target.files[0].name);
      let uploadedFileResult;
      if (store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled) {
        uploadedFileResult = await store.files.uploadFileViaPresignedUrlExperimentAsync.run({
          file: e.target.files[0],
          createdBy: store.account.userProfile.id
        });
      } else {
        uploadedFileResult = await store.files.uploadFileAsync.run({
          file: e.target.files[0]
        });
      }
      const uploadResult = {};
      uploadResult.fileResponse = (_uploadedFileResult = uploadedFileResult) !== null && _uploadedFileResult !== void 0 && _uploadedFileResult.isSuccessful ? uploadedFileResult.response : uploadedFileResult;
      const parseResult = await parseCsv(e.target.files[0], residenciesData);
      return callback(_objectSpread(_objectSpread({}, parseResult), uploadResult));
    }
  };
  const handleDelete = () => {
    setValue('');
    fileInputRef.current.value = null;
    if (typeof callback === 'function') {
      callback(null);
    }
  };
  const onDragStart = () => {
    setIsDrag(true);
  };
  const onDragEnd = () => {
    setIsDrag(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(value && value.length ? 'active' : '', " ").concat(classes.dropArea, " ").concat(isDrag ? 'drag' : '', " ").concat(disabled ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.fileInfo, " ").concat(value && value.length > 0 ? '' : 'center')
  }, !noPreview && value && value.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.preview,
    onClick: () => {
      setIsFilePreviewModalOpen(!isFilePreviewModalOpen);
    },
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        setIsFilePreviewModalOpen(!isFilePreviewModalOpen);
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "link"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.name
  }, value && value.length > 0 && /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("span", null, value)), (!value || value.length === 0) && /*#__PURE__*/React.createElement(Typography, {
    component: "p",
    variant: "h5"
  }, "Drag and drop here or ", /*#__PURE__*/React.createElement("span", null, "click to browse from your files "))), !noPreview && value && value.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.previewBill
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      setIsFilePreviewModalOpen(!isFilePreviewModalOpen);
    },
    'custom-attribute': '499-CSV-file-uploader'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "zoom-in"
  }), /*#__PURE__*/React.createElement("span", null, "Preview bill")))), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, !disabled && value && value.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.remove
  }, /*#__PURE__*/React.createElement(RemoveFileModal, {
    callback: handleDelete,
    trigger: /*#__PURE__*/React.createElement(IconButton, {
      'custom-attribute': '500-CSV-file-uploader'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "trash"
    }))
  })), /*#__PURE__*/React.createElement("input", {
    type: "file",
    ref: fileInputRef,
    disabled: disabled,
    onChange: handleFileChange,
    onDragEnter: onDragStart,
    onFocus: onDragStart,
    onDragLeave: onDragEnd,
    onBlur: onDragEnd,
    onDrop: onDragEnd
  }))));
}
CsvFileUploader.propTypes = {
  callback: PropTypes.func,
  noPreview: PropTypes.bool,
  disabled: PropTypes.bool
};